import { freestallVentilation } from './freestallVentilation';
import { medias } from './../Global/medias.js';

class FreestallVentilationSlides {
  constructor(app, report, evaluation, group, user) {
    this.app = app;
    this.report = report;
    this.evaluation = evaluation;
    this.group = group;
    this.user = user;
  }

  add(tableOfContentsCalculatorPosition) {
    let assessor = this.group.getAssessorByType('12');

    if (assessor === false || assessor.assessor.data === undefined) {
      throw (
        this.group.getName() +
        this.app.$t(' - ') +
        this.app.$t('Freestall Ventilation assessor is not ready.')
      );
    }

    this.report.tableOfContentsHelper(
      'Freestall Ventilation',
      tableOfContentsCalculatorPosition,
      this.group,
    );

    freestallVentilation(this.app, this.report, this.evaluation, this.group, assessor);
    medias(this.app, this.report, this.group, '12', this.user);
  }
}

export default FreestallVentilationSlides;
